import React from 'react';
import { useAuth } from '../context/AuthContext';

const AuthErrorDisplay = () => {
  const { error, clearError } = useAuth();

  if (!error) {
    return null;
  }

  return (
    <div 
      className="alert alert-danger alert-dismissible fade show" 
      role="alert"
      style={{
        position: 'fixed',
        top: '20px',
        right: '20px',
        zIndex: 9999,
        maxWidth: '400px',
        boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)'
      }}
    >
      <strong>Authentication Error:</strong> {error}
      <button 
        type="button" 
        className="btn-close" 
        onClick={clearError}
        aria-label="Close"
      ></button>
    </div>
  );
};

export default AuthErrorDisplay;
